import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77bcb5cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personal__name" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "personal__setting" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "new-badge" }, "new", -1))
const _hoisted_5 = { class: "personal__footer" }
const _hoisted_6 = { class: "personal__footer-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TdVipBadge = _resolveComponent("TdVipBadge")!
  const _component_DeviceList = _resolveComponent("DeviceList")!
  const _component_SettingItem = _resolveComponent("SettingItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["personal", { 'is-vip': _ctx.isVip }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["personal__body", { 'is-vip': _ctx.isVip }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.avatarURL,
          class: "avatar",
          alt: "头像"
        }, null, 8, _hoisted_2),
        _createElementVNode("section", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.nickName), 1),
          _createVNode(_component_TdVipBadge, {
            "vip-level": _ctx.user?.vipLevel,
            "is-vip": _ctx.user?.isVip,
            "is-year": _ctx.user?.isYear,
            "vas-type": _ctx.user?.vipType,
            size: "large"
          }, null, 8, ["vip-level", "is-vip", "is-year", "vas-type"])
        ])
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["personal__tip vip", { 'is-vip': _ctx.isVip }])
      }, [
        _createElementVNode("span", null, _toDisplayString(!_ctx.isVip ? '您还不是会员 开通享下载加速特权' : `您的会员时长剩余 ${_ctx.expiresLast}天`), 1),
        (_ctx.showVip)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "personal__tip-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goVip && _ctx.goVip(...args)))
            }, _toDisplayString(_ctx.isVip ? (_ctx.isSuperVip ? '续费会员' : '升级超会') : '开通会员'), 1))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isXunlei)
        ? (_openBlock(), _createBlock(_component_SettingItem, {
            key: 0,
            title: "远程设备",
            "list-title": "设备管理",
            "click-id": "remote_device"
          }, {
            extra: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['cureent-device', _ctx.currentStatus === 1 ? 'active' : '', _ctx.DEVICE_STATUS_CLASS[_ctx.currentStatus]])
              }, [
                _createElementVNode("span", null, _toDisplayString(`   ${_ctx.currentName}`), 1),
                _createElementVNode("label", null, _toDisplayString(`(${_ctx.DEVICE_STATUS[_ctx.currentStatus] || '离线'})  `), 1)
              ], 2)
            ]),
            content: _withCtx((props) => [
              _createVNode(_component_DeviceList, {
                close: props.close
              }, null, 8, ["close"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_SettingItem, {
            key: 1,
            "native-click": "",
            title: "设备管理",
            "click-id": "deviceInfo",
            onClick: _ctx.handleShowDeviceInfo
          }, {
            extra: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['cureent-device', _ctx.currentStatus === 1 ? 'active' : '', _ctx.DEVICE_STATUS_CLASS[_ctx.currentStatus]])
              }, [
                _createElementVNode("span", null, _toDisplayString(`   ${_ctx.currentName}`), 1),
                _createElementVNode("label", null, _toDisplayString(`（${_ctx.DEVICE_STATUS[_ctx.currentStatus] || '离线'}）`), 1)
              ], 2)
            ]),
            _: 1
          }, 8, ["onClick"])),
      _createVNode(_component_SettingItem, {
        "native-click": "",
        title: "磁盘管理",
        "click-id": "deviceInfo",
        onClick: _ctx.handleShowDisks
      }, null, 8, ["onClick"]),
      _createVNode(_component_SettingItem, {
        "native-click": "",
        title: "服务更新",
        "click-id": "services",
        onClick: _ctx.gotoServicePage
      }, _createSlots({ _: 2 }, [
        (_ctx.hasNewVersion)
          ? {
              name: "extra",
              fn: _withCtx(() => [
                _hoisted_4
              ])
            }
          : undefined
      ]), 1032, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_SettingItem, {
          "native-click": "",
          title: "联系客服",
          "click-id": "help",
          onClick: _ctx.gotoHelpPage
        }, null, 8, ["onClick"]),
        _createVNode(_component_SettingItem, {
          "native-click": "",
          title: "更多",
          "click-id": "more",
          onClick: _ctx.handleShowMore
        }, null, 8, ["onClick"])
      ])
    ])
  ], 2))
}